import { useState } from 'react'

import { ICON_HEIGHT_24, IconNG } from '../../Icon'
import { Component, ComponentProps } from '../Component'
import { controls, number, text } from '../Controls'

import BuldingIcon from '../../../icons/building.svg'

function Icon() {
  const [props, setProps] = useState(() =>
    controls() //
      .add(number('size', ICON_HEIGHT_24))
      .add(text('color', 'var(--secondary-text-color)'))
      .add(text('qaName'))
  )

  return (
    <>
      <Component
        {...props.getValues()}
        Component={IconNG}
        Icon={BuldingIcon}
        name='Icon'
      />
      <ComponentProps name='Icon' value={props} onChange={setProps} />
    </>
  )
}

export default Icon
